import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialStripComponent } from './components/social-strip/social-strip.component';
import { NgxGlideModule } from 'ngx-glide';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    NgxGlideModule,
    SharedModule
  ],
  declarations: [SocialStripComponent],
  exports: [SocialStripComponent],
})
export class SocialStripModule { }
